module.exports = __webpack_public_path__ + "static/media/service_details_one.50b85aeb.png";